import React, { useState, useEffect, Fragment } from "react";
import { useTranslation } from "react-i18next";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import addDays from "date-fns/addDays";
import addHours from "date-fns/addHours";
import parseISO from "date-fns/parseISO";
import { Modal, ModalBody } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSave,
  faTimesCircle,
  faArrowCircleRight,
  faArrowCircleLeft,
} from "@fortawesome/free-solid-svg-icons";
import { ResponseSuccessModal, ResponseFailModal } from "../../modal/Response";
import Spin from "../../Spin";
import { SMSSend } from "../../SMSSend";
import countryInfo from "../../../assets/countries.json";
import * as api from "../../../api";
import moment from "moment";

const BookingCreate = ({ isOpen, toggle, reload }) => {
  const { t } = useTranslation();
  const hotelId = localStorage.getItem("hotel_id");
  const keyTypeList = [
    { key: t("data.key_type.pincode"), value: "pincode" },
    { key: t("data.key_type.mobilekey"), value: "mobilekey" },
  ];
  const pincodeTypeV2List = [
    { key: t("data.pincode_type.day"), value: "day" },
    { key: t("data.pincode_type.hour"), value: "hour" },
    { key: t("data.pincode_type.min"), value: "10mins" },
  ];
  const pincodeTypeV3List = [
    { key: t("data.pincode_type.hour"), value: "hour" },
  ];
  const howToIssueV2List = [
    { key: t("data.issue_type.copy"), value: false },
    { key: t("data.issue_type.new"), value: true },
  ];
  const howToIssueList = [{ key: t("data.issue_type.copy"), value: false }];

  const countryInfoList = Object.values(countryInfo);
  const [isLoading, setIsLoading] = useState(false);
  const [countryNumber, setCountryNumber] = useState("82");
  // const [ pincodeDayTypeOffset, setPincodeDayTypeOffset ] = useState('');
  const [isOpenBookingCreateSuccessModal, setIsOpenBookingCreateSuccessModal] =
    useState(false);
  const [
    isOpenRequiredParameterFailModal,
    setIsOpenRequiredParameterFailModal,
  ] = useState(false);
  const [isOpenBookingCreateFailModal, setIsOpenBookingCreateFailModal] =
    useState(false);
  const [messageBookingCreateFail, setMessageBookingCreateFail] = useState("");
  const [isOpenKeyIssueSuccessModal, setIsOpenKeyIssueSuccessModal] =
    useState(false);
  const [isOpenKeyIssueFailModal, setIsOpenKeyIssueFailModal] = useState(false);
  const [messageKeyIssueFail, setMessageKeyIssueFail] = useState("");
  const [activePage, setActivePage] = useState(1);
  const [buildingItems, setBuildingItems] = useState([]);
  const [roomItems, setRoomItems] = useState([]);
  const [commonroomItems, setCommonroomItems] = useState([]);
  const [selectedBuildingId, setSelectedBuildingId] = useState("");
  const [selectedKeyType, setSelectedKeyType] = useState("pincode");
  const [limitCheckInOutAt, setLimitCheckInOutAt] = useState({
    minCheckinAt: "",
    maxCheckoutAt: "",
  });
  const [selectedBookingId, setSelectedBookingId] = useState("");
  const [bookingCreateItem, setBookingCreateItem] = useState({
    userName: "",
    phoneNumber: "",
    desc: "",
    roomIds: [],
    commonroomIds: [],
    checkinAt: "",
    checkoutAt: "",
  });
  const [keyIssueItem, setKeyIssueItem] = useState({
    keyType: "",
    userName: "",
    phoneNumber: "",
    type: "",
    isNew: false,
    checkinAt: "",
    checkoutAt: "",
  });
  const [SMSSendItem, setSMSSendItem] = useState({
    type: "",
    value: "",
    keyId: "",
  });
  const [roomUpdateItem, setRoomUpdateItem] = useState({
    roomId: "",
    name: "",
    floorId: "",
    rmsId: "",
    allowKeytag: "",
    advertiseStrength: "",
    connectedStrength: "",
    status: "",
    buildingName: "",
    floorName: "",
    createdAt: "",
    updatedAt: "",
    doorlock: {
      doorlockId: "",
      dlSerial: "",
      name: "",
      pincodeVersion: "",
    },
  });
  const [hotelUpdateItem, setHotelUpdateItem] = useState({
    name: "",
    timezone: "",
    address: "",
    desc: "",
    pincodeVersion: "",
    pincodeLength: "",
    pincodeDayTypeOffset: "",
    allowInfinityPincode: "",
    pincodeAuthTimeoutMin: "",
    useSlimkey: "",
    commonrooms: "",
    notifyChannelId: "",
    apphotelstory: "",
    appElevatorBtn: "",
    doorlockDeletable: "",
    role: "",
    notifyEmail: "",
  });
  const checkinAtV4HH = Array.from({ length: 23 }, (v, i) => i + 1);
  const checkinAtV4MM = Array.from({ length: 59 }, (v, i) => i + 1);

  const changeBookingCheckinAt = (date) => {
    date.setSeconds(0, 0);
    setBookingCreateItem({
      ...bookingCreateItem,
      checkinAt: date,
    });
  };

  const changeBookingCheckoutAt = (date) => {
    date.setSeconds(0, 0);
    setBookingCreateItem({
      ...bookingCreateItem,
      checkoutAt: date,
    });
  };

  const validateStartAt = (time) => {
    const selectedDate = new Date(time);
    console.log(
      limitCheckInOutAt,
      "limitCheckInOutAtlimitCheckInOutAtlimitCheckInOutAtlimitCheckInOutAtlimitCheckInOutAt"
    );
    return (
      limitCheckInOutAt.minCheckinAt.getTime() <= selectedDate.getTime() &&
      selectedDate.getTime() < limitCheckInOutAt.maxCheckoutAt.getTime()
    );
  };

  const validateEndAt = (time) => {
    const selectedDate = new Date(time);
    return (
      limitCheckInOutAt.minCheckinAt.getTime() < selectedDate.getTime() &&
      selectedDate.getTime() <= limitCheckInOutAt.maxCheckoutAt.getTime()
    );
  };

  const changeKeyStartAt = (date) => {
    date.setSeconds(0, 0);
    setKeyIssueItem({
      ...keyIssueItem,
      checkinAt: date,
    });
  };

  const changeKeyEndAt = (date) => {
    date.setSeconds(0, 0);
    setKeyIssueItem({
      ...keyIssueItem,
      checkoutAt: date,
    });
  };

  const changeKeyStartAt2 = (date) => {
    const value =
      date < limitCheckInOutAt.minCheckinAt
        ? limitCheckInOutAt.minCheckinAt
        : date.setSeconds(0, 0);
    setKeyIssueItem({
      ...keyIssueItem,
      checkinAt: value,
    });
  };

  const changeKeyEndAt2 = (date) => {
    const value =
      date > limitCheckInOutAt.maxCheckoutAt
        ? limitCheckInOutAt.maxCheckoutAt
        : date.setSeconds(0, 0);
    setKeyIssueItem({
      ...keyIssueItem,
      checkoutAt: value,
    });
  };

  const changeCommonroom = (selectedCommonrooms) => {
    setBookingCreateItem({
      ...bookingCreateItem,
      commonroomIds: selectedCommonrooms
        ? selectedCommonrooms.map((commonroom) => commonroom.value)
        : [],
    });
  };

  const changeKeyType = (keyType) => {
    setSelectedKeyType(keyType);
    if (keyType === "mobilekey")
      setKeyIssueItem({
        ...keyIssueItem,
        checkinAt: limitCheckInOutAt.minCheckinAt,
        checkoutAt: limitCheckInOutAt.maxCheckoutAt,
      });
    else changePincodeType("day");
  };

  const changePincodeType = (pincodeType) => {
    switch (pincodeType) {
      case "day":
        return setKeyIssueItem({
          ...keyIssueItem,
          type: pincodeType,
          checkinAt: limitCheckInOutAt.minCheckinAt,
          checkoutAt: limitCheckInOutAt.maxCheckoutAt,
        });
      case "hour":
        const add1Days = addDays(limitCheckInOutAt.minCheckinAt, 1);
        return setKeyIssueItem({
          ...keyIssueItem,
          type: pincodeType,
          checkinAt: limitCheckInOutAt.minCheckinAt,
          checkoutAt:
            add1Days > limitCheckInOutAt.maxCheckoutAt
              ? limitCheckInOutAt.maxCheckoutAt
              : add1Days,
        });
      case "10mins":
        const add5Hours = addHours(limitCheckInOutAt.minCheckinAt, 5);
        return setKeyIssueItem({
          ...keyIssueItem,
          type: pincodeType,
          checkinAt: limitCheckInOutAt.minCheckinAt,
          checkoutAt:
            add5Hours > limitCheckInOutAt.maxCheckoutAt
              ? limitCheckInOutAt.maxCheckoutAt
              : add5Hours,
        });
      default:
        return setKeyIssueItem({
          ...keyIssueItem,
          type: pincodeType,
          checkinAt: "",
          checkoutAt: "",
        });
    }
  };

  const setTimeInterval = () => {
    const formatter = {
      day: 60,
      hour: 60,
      "10mins": 10,
    };
    return formatter[keyIssueItem.type] || 60;
  };

  const setMaxDate = () => {
    // if (selectedKeyType === 'pincode' && pincodeIssueItem.type === 'day' && bookingCreateItem.checkinAt) return addDays(bookingCreateItem.checkinAt, 15);
    // if (selectedKeyType === 'pincode' && pincodeIssueItem.type === 'hour' && bookingCreateItem.checkinAt) return addDays(bookingCreateItem.checkinAt, 1);
    // return '';
    return addDays(parseISO(bookingCreateItem.checkinAt), 15);
  };

  const validateCreateBookingItem = ({
    userName,
    phoneNumber,
    checkinAt,
    checkoutAt,
    roomIds,
  }) => {
    return (
      userName && phoneNumber && checkinAt && checkoutAt && roomIds.length > 0
    );
  };

  const validateIssueKeyItem = ({
    userName,
    phoneNumber,
    checkinAt,
    checkoutAt,
  }) => {
    return userName && phoneNumber && checkinAt && checkoutAt;
  };

  const createBooking = async () => {
    try {
      if (!validateCreateBookingItem(bookingCreateItem))
        setIsOpenRequiredParameterFailModal(true);
      else {
        setIsLoading(true);
        const reqNum =
          countryNumber + Number.parseInt(bookingCreateItem.phoneNumber);
        const res = await api.createBooking({
          ...bookingCreateItem,
          phoneNumber: reqNum,
        });
        setSelectedBookingId(res.data.id);
        setKeyIssueItem({
          userName: res.data.user.name,
          phoneNumber: res.data.user.phone_number,
          type: "day",
          isNew: false,
          checkinAt: new Date(res.data.checkin_at),
          checkoutAt: new Date(res.data.checkout_at),
        });
        setLimitCheckInOutAt({
          minCheckinAt: new Date(res.data.checkin_at),
          maxCheckoutAt: new Date(res.data.checkout_at),
        });
        setActivePage(2);
      }
    } catch (error) {
      if (!error.response) setMessageBookingCreateFail(error.message);
      else
        setMessageBookingCreateFail(
          `${error.response.data.code}, ${error.response.data.message}`
        );
      setIsOpenBookingCreateFailModal(true);
    } finally {
      setIsLoading(false);
    }
  };

  const cancelBooking = async () => {
    try {
      setIsLoading(true);
      await api.cancelBooking({ bookingId: selectedBookingId });
      setSelectedBookingId("");
      setActivePage(1);
    } catch (error) {
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  const issueKey = async () => {
    try {
      if (!validateIssueKeyItem(keyIssueItem))
        setIsOpenRequiredParameterFailModal(true);
      else {
        setIsLoading(true);
        if (selectedKeyType === "mobilekey") await issueUserMobilekey();
        else await issueUserPincode();
        setIsOpenKeyIssueSuccessModal(true);
      }
    } catch (error) {
      if (!error.response) setMessageKeyIssueFail(error.message);
      else
        setMessageKeyIssueFail(
          `${error.response.data.code}, ${error.response.data.message}`
        );
      setIsOpenKeyIssueFailModal(true);
    } finally {
      setIsLoading(false);
    }
  };

  const issueUserMobilekey = async () => {
    try {
      const res = await api.issueUserMobilekey({
        bookingId: selectedBookingId,
        ...keyIssueItem,
      });
      setSMSSendItem({
        ...SMSSendItem,
        type: "mobilekey",
        value: res.data.exchangekey,
        keyId: res.data.user_id,
      });
    } catch (error) {
      throw error;
    }
  };

  const issueUserPincode = async () => {
    try {
      const res = await api.issueUserPincode({
        bookingId: selectedBookingId,
        ...keyIssueItem,
      });
      setSMSSendItem({
        ...SMSSendItem,
        type: "pincode",
        value: res.data.pincode,
        keyId: res.data.pincode_id,
      });
    } catch (error) {
      throw error;
    }
  };

  const handleChangeRoom = (e) => {
    setBookingCreateItem({ ...bookingCreateItem, roomIds: [e.target.value] });
    handleSelectRoom(e.target.value);
  };

  const handleSelectRoom = async (selectRoomId) => {
    try {
      const res = await api.selectRoomId({
        buildingId: selectedBuildingId,
        roomId: selectRoomId,
      });
      setRoomUpdateItem({
        roomId: res.data.id,
        name: res.data.name,
        floorId: res.data.floor_id,
        rmsId: res.data.rms_id,
        allowKeytag: res.data.allow_keytag,
        advertiseStrength: res.data.advertise_strength,
        connectedStrength: res.data.connected_strength,
        status: res.data.status,
        buildingName: res.data.building_name,
        floorName: res.data.floor_name,
        createdAt: res.data.created_at,
        updatedAt: res.data.updated_at,
        doorlock: {
          doorlockId: res.data.doorlock.id,
          dlSerial: res.data.doorlock.dl_serial,
          name: res.data.doorlock.name,
          pincodeVersion: res.data.doorlock.pincode_version,
        },
      });
    } catch (error) {
      throw error;
    }
  };

  const hnadleChangeDateV4 = (type, e) => {
    const { value } = e.target;
    const check_year = moment(keyIssueItem.checkinAt).year();
    const check_month = moment(keyIssueItem.checkinAt).month() + 1;
    const check_date = moment(keyIssueItem.checkinAt).date();
    const check_hour = moment(keyIssueItem.checkinAt).hour();
    const check_minute = moment(keyIssueItem.checkinAt).minute();
    const new_day = `${check_year}-${
      check_month < 10 ? "0" + check_month : check_month
    }-${check_date < 10 ? "0" + check_date : check_date}`;
    const new_date =
      type === "HH"
        ? `${new_day} ${value}:${
            check_minute < 10 ? "0" + check_minute : check_minute
          }`
        : `${new_day} ${
            check_hour < 10 ? "0" + check_hour : check_hour
          }:${value}`;
    const result_date =
      new Date(new_date).getTime() < bookingCreateItem.checkinAt.getTime()
        ? bookingCreateItem.checkinAt
        : new_date;

    setKeyIssueItem({
      ...keyIssueItem,
      checkinAt: new Date(result_date),
    });
  };

  const selectHotel = async () => {
    try {
      setIsLoading(true);
      const res = await api.selectHotel();
      setHotelUpdateItem({
        name: res.data.name,
        timezone: res.data.timezone,
        address: res.data.address,
        desc: res.data.desc,
        pincodeVersion: res.data.pincode_version,
        pincodeLength: res.data.pincode_length,
        pincodeDayTypeOffset: res.data.pincode_day_type_offset,
        allowInfinityPincode: res.data.allow_infinity_pincode,
        pincodeAuthTimeoutMin: res.data.pincode_auth_timeout_min,
        useSlimkey: res.data.use_slimkey,
        commonrooms: res.data.commonrooms,
        notifyChannelId: res.data.notify_channel_id,
        apphotelstory: res.data.app_hotelstory,
        appElevatorBtn: res.data.app_elevator_btn,
        doorlockDeletable: res.data.doorlock_deletable,
        role: res.data.role,
        notifyEmail: res.data.notify_email,
      });
    } catch (error) {
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    selectHotel();
  }, []);

  useEffect(() => {
    const listCommonroom = async () => {
      try {
        const res = await api.listCommonroomDoorlock({
          buildingId: selectedBuildingId,
        });
        setCommonroomItems(
          res.data.map((commonroom) => {
            return {
              value: commonroom.id,
              label: commonroom.name,
              isDisabled: commonroom.status !== "installed",
            };
          })
        );
      } catch (error) {
        throw error;
      }
    };
    if (selectedBuildingId) listCommonroom();
  }, [selectedBuildingId]);

  useEffect(() => {
    const listRoom = async () => {
      try {
        setIsLoading(true);
        const res = await api.listRoom({ buildingId: selectedBuildingId });
        setRoomItems(res.data.items);
      } catch (error) {
        throw error;
      } finally {
        setIsLoading(false);
      }
    };
    if (selectedBuildingId) listRoom();
  }, [selectedBuildingId]);

  useEffect(() => {
    const listBuilding = async () => {
      try {
        const res = await api.listBuilding({});
        setBuildingItems(res.data.items);
      } catch (error) {
        throw error;
      }
    };
    if (hotelId) listBuilding();
  }, [hotelId]);

  // useEffect(() => {
  //   const selectHotel = async () => {
  //     try {
  //       const res = await api.selectHotel();
  //       setPincodeDayTypeOffset(res.data.pincode_day_type_offset);
  //     } catch (error) {
  //       throw error;
  //     }
  //   };
  //   if (hotelId) selectHotel();
  // }, [hotelId]);

  useEffect(() => {
    const init = () => {
      setBookingCreateItem({
        userName: "",
        phoneNumber: "",
        desc: "",
        roomIds: [],
        commonroomIds: [],
        checkinAt: "",
        checkoutAt: "",
      });
      setKeyIssueItem({
        userName: "",
        phoneNumber: "",
        type: "",
        isNew: false,
        checkinAt: "",
        checkoutAt: "",
      });
      setLimitCheckInOutAt({
        minCheckinAt: "",
        maxCheckoutAt: "",
      });
      setSMSSendItem({
        type: "",
        value: "",
        keyId: "",
      });
      setCountryNumber("82");
      setSelectedBuildingId("");
      setSelectedKeyType("pincode");
      setActivePage(1);
      setSelectedBookingId("");
    };
    init();
  }, [isOpen]);

  const hourV4 =
    moment(keyIssueItem.checkinAt).hour() > 9
      ? moment(keyIssueItem.checkinAt).hour()
      : `0${moment(keyIssueItem.checkinAt).hour()}`;
  const minuteV4 =
    moment(keyIssueItem.checkinAt).minute() > 9
      ? moment(keyIssueItem.checkinAt).minute()
      : `0${moment(keyIssueItem.checkinAt).minute()}`;

  return (
    <Fragment>
      <Modal
        show={isOpen}
        onHide={() => toggle()}
        centered
        backdrop="static"
        size="md"
      >
        <Spin isSpin={isLoading} isModal={true} />
        <ModalBody
          className="text-center m-3"
          style={{ margin: 0, padding: 0, backgroundColor: "#282C34" }}
        >
          <div className="form-card" hidden={activePage !== 1}>
            <div className="form-card-title">
              <h4>{t("content_title.booking_add")}</h4>
            </div>
            <div className="inline-flex">
              <div className="w-100">
                <div className="card-text">
                  <p>
                    {/* <FontAwesomeIcon icon={faHourglassStart}/> */}
                    <b>{t("data_column.checkin_at")}</b>
                    <span className="required">*</span>
                  </p>
                  <DatePicker
                    dateFormat="yyyy-MM-dd HH:mm"
                    placeholderText={t("placeholder.checkin_at")}
                    selected={bookingCreateItem.checkinAt}
                    selectsStart
                    minDate={new Date()}
                    endDate={bookingCreateItem.checkoutAt}
                    showTimeSelect
                    timeFormat="HH:mm"
                    timeIntervals={setTimeInterval()}
                    timeCaption="Time"
                    onChange={(date) => changeBookingCheckinAt(date)}
                    withPortal
                  />
                </div>
                <div className="card-text">
                  <p>
                    {/* <FontAwesomeIcon icon={faHourglassEnd}/> */}
                    <b>{t("data_column.checkout_at")}</b>
                    <span className="required">*</span>
                  </p>
                  <DatePicker
                    disabled={!bookingCreateItem.checkinAt}
                    dateFormat="yyyy-MM-dd HH:mm"
                    placeholderText={t("placeholder.checkout_at")}
                    selected={bookingCreateItem.checkoutAt}
                    selectsEnd
                    minDate={bookingCreateItem.checkinAt}
                    maxDate={setMaxDate()}
                    startDate={bookingCreateItem.checkinAt}
                    showTimeSelect
                    timeFormat="HH:mm"
                    timeIntervals={setTimeInterval()}
                    timeCaption="Time"
                    onChange={(date) => changeBookingCheckoutAt(date)}
                    withPortal
                  />
                </div>
                <div className="card-text">
                  <p>
                    {/* <FontAwesomeIcon icon={faBuilding}/> */}
                    <b>{t("data_column.building")}</b>
                    <span className="required">*</span>
                  </p>
                  <select
                    className="card-text-select"
                    value={selectedBuildingId}
                    onChange={(e) => setSelectedBuildingId(e.target.value)}
                  >
                    <option value="" hidden>
                      {t("placeholder.building_select")}
                    </option>
                    {buildingItems.map((building, index) => (
                      <option key={index} value={building.id}>
                        {building.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="card-text">
                  <p>
                    {/* <FontAwesomeIcon icon={faBed}/> */}
                    <b>{t("data_column.room")}</b>
                    <span className="required">*</span>
                  </p>
                  <select
                    className="card-text-select"
                    value={bookingCreateItem.roomIds[0]}
                    onChange={handleChangeRoom}
                  >
                    <option value="" hidden>
                      {t("placeholder.room_select")}
                    </option>
                    {roomItems.map((room, index) => (
                      <option
                        key={index}
                        value={room.id}
                        disabled={room.status !== "installed"}
                      >
                        {room.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="card-text">
                  <p>
                    {/* <FontAwesomeIcon icon={faDoorClosed}/> */}
                    <b>{t("data_column.commonroom_name")}</b>
                  </p>
                  <Select
                    styles={{
                      menu: (provided) => ({
                        ...provided,
                        backgroundColor: "#1c2025",
                      }),
                      option: (provided, state) => ({
                        ...provided,
                        backgroundColor: "#1c2025",
                        color: state.isDisabled ? "#68696d" : "#e6e5e8",
                        "&:hover": {
                          backgroundColor: state.isDisabled
                            ? ""
                            : "rgba(255, 255, 255, 0.04)",
                        },
                      }),
                    }}
                    placeholder={t("placeholder.commonroom_select")}
                    noOptionsMessage={() => ""}
                    isMulti
                    vlaue={bookingCreateItem.commonroomIds || []}
                    onChange={(state) => changeCommonroom(state)}
                    closeMenuOnSelect={false}
                    name="commonrooms"
                    options={commonroomItems}
                    className="basic-multi-select"
                    classNamePrefix="select"
                  />
                </div>
                <div className="card-text">
                  <p>
                    {/* <FontAwesomeIcon icon={faUserAlt}/> */}
                    <b>{t("data_column.user_name")}</b>
                    <span className="required">*</span>
                  </p>
                  <input
                    className="card-text-input"
                    placeholder={t("placeholder.user_name")}
                    onChange={(e) =>
                      setBookingCreateItem({
                        ...bookingCreateItem,
                        userName: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="card-text">
                  <p>
                    {/* <FontAwesomeIcon icon={faPhone}/> */}
                    <b>{t("data_column.phone_number")}</b>
                    <span className="required">*</span>
                  </p>
                  <select
                    className="card-text-select"
                    value={countryNumber}
                    onChange={(e) => setCountryNumber(e.target.value)}
                  >
                    {countryInfoList.map((country, index) => (
                      <option
                        key={`country-index-${index}`}
                        value={country.phone}
                      >{`${country.name} ( +${country.phone} )`}</option>
                    ))}
                  </select>
                  <p></p>
                  <input
                    className="card-text-input"
                    placeholder={t("placeholder.phone_number")}
                    maxLength="11"
                    onChange={(e) =>
                      setBookingCreateItem({
                        ...bookingCreateItem,
                        phoneNumber: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="card-text">
                  <p>
                    {/* <FontAwesomeIcon icon={faClipboard}/> */}
                    <b>{t("data_column.description")}</b>
                  </p>
                  <input
                    className="card-text-input"
                    placeholder={t("placeholder.description_booking")}
                    onChange={(e) =>
                      setBookingCreateItem({
                        ...bookingCreateItem,
                        desc: e.target.value,
                      })
                    }
                  />
                </div>
              </div>
            </div>
            <div className="card-foot">
              <div className="form-item-cancel">
                <button className="btn-item-cancel" onClick={() => toggle()}>
                  <FontAwesomeIcon
                    icon={faTimesCircle}
                    style={{ paddingRight: "3px" }}
                  />
                  <span>{t("button.cancel")}</span>
                </button>
              </div>
              <div className="form-item-add center">
                <button
                  className="btn-item-add"
                  onClick={() => createBooking()}
                >
                  <FontAwesomeIcon
                    icon={faArrowCircleRight}
                    style={{ paddingRight: "3px" }}
                  />
                  <span>{t("button.next")}</span>
                </button>
              </div>
            </div>
          </div>
          <div className="form-card" hidden={activePage !== 2}>
            <div className="form-card-title">
              <h4>{t("content_title.key_issue")}</h4>
            </div>
            <div className="inline-flex">
              <div className="w-100">
                <div className="card-text">
                  <p>
                    {/* <FontAwesomeIcon icon={faKey}/> */}
                    <b>{t("data_column.key_type")}</b>
                    <span className="required">*</span>
                  </p>
                  <select
                    className="card-text-select"
                    value={selectedKeyType}
                    onChange={(e) => changeKeyType(e.target.value)}
                  >
                    <option value="" hidden>
                      {t("placeholder.type_select")}
                    </option>
                    {keyTypeList.map((keyType, index) => (
                      <option key={index} value={keyType.value}>
                        {keyType.key}
                      </option>
                    ))}
                  </select>
                </div>
                <div
                  className="card-text"
                  hidden={
                    selectedKeyType !== "pincode" ||
                    roomUpdateItem.doorlock.pincodeVersion === "V4"
                  }
                >
                  <p>
                    {/* <FontAwesomeIcon icon={faTag}/> */}
                    <b>{t("data_column.pincode_type")}</b>
                    <span className="required">*</span>
                  </p>
                  <select
                    className="card-text-select"
                    value={keyIssueItem.type}
                    onChange={(e) => changePincodeType(e.target.value)}
                  >
                    {roomUpdateItem.doorlock.pincodeVersion === "V3"
                      ? pincodeTypeV3List.map((type, index) => (
                          <option key={index} value={type.value}>
                            {type.key}
                          </option>
                        ))
                      : pincodeTypeV2List.map((type, index) => (
                          <option key={index} value={type.value}>
                            {type.key}
                          </option>
                        ))}
                  </select>
                </div>

                {/* 핀코드 V4 일 경우 */}
                {roomUpdateItem.doorlock.pincodeVersion === "V4" &&
                  selectedKeyType === "pincode" && (
                    <>
                      <div className="card-text">
                        <p>
                          {/* <FontAwesomeIcon icon={faHourglassStart}/> */}
                          <b>{t("data_column.start_at")}</b>
                          <span className="required">*</span>
                        </p>
                        <div className="card-text-date-V4">
                          <DatePicker
                            disabled={
                              selectedKeyType === "pincode" &&
                              !keyIssueItem.type
                            }
                            dateFormat="yyyy-MM-dd"
                            placeholderText={t("placeholder.start_at")}
                            selected={keyIssueItem.checkinAt}
                            selectsStart
                            minDate={limitCheckInOutAt.minCheckinAt}
                            maxDate={limitCheckInOutAt.maxCheckoutAt}
                            endDate={keyIssueItem.checkoutAt}
                            showTimeSelect={false}
                            filterTime={validateStartAt}
                            timeFormat="HH:mm"
                            timeIntervals={setTimeInterval()}
                            timeCaption="Time"
                            onChange={(date) => changeKeyStartAt2(date)}
                            withPortal
                            style={{ marginRight: "1rem" }}
                          />

                          <select
                            className="card-text-select"
                            name="checkinAt-hh"
                            onChange={(e) => hnadleChangeDateV4("HH", e)}
                            value={hourV4}
                          >
                            <option value="00">00</option>
                            {checkinAtV4HH.map((value, index) => {
                              const hh_value = value > 9 ? value : `0${value}`;
                              return (
                                <option key={hh_value} value={hh_value}>
                                  {hh_value}
                                </option>
                              );
                            })}
                          </select>
                          <select
                            className="card-text-select"
                            name="checkinAt-mm"
                            onChange={(e) => hnadleChangeDateV4("MM", e)}
                            value={minuteV4}
                          >
                            <option value="00">00</option>
                            {checkinAtV4MM.map((value, index) => {
                              const mm_value = value > 9 ? value : `0${value}`;
                              return (
                                <option key={mm_value} value={mm_value}>
                                  {mm_value}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                      </div>
                      <div className="card-text">
                        <p>
                          {/* <FontAwesomeIcon icon={faHourglassEnd}/> */}
                          <b>{t("data_column.end_at")}</b>
                          <span className="required">*</span>
                        </p>
                        <DatePicker
                          disabled={!keyIssueItem.checkinAt}
                          dateFormat="yyyy-MM-dd HH:mm"
                          placeholderText={t("placeholder.end_at")}
                          selected={keyIssueItem.checkoutAt}
                          selectsEnd
                          minDate={limitCheckInOutAt.minCheckinAt}
                          maxDate={limitCheckInOutAt.maxCheckoutAt}
                          startDate={keyIssueItem.checkinAt}
                          showTimeSelect={false}
                          filterTime={validateEndAt}
                          timeFormat="HH:mm"
                          timeIntervals={setTimeInterval()}
                          timeCaption="Time"
                          onChange={(date) => changeKeyEndAt2(date)}
                          withPortal
                        />
                      </div>
                    </>
                  )}
                {/* 핀코드 V4가 아닐 경우 */}
                {(roomUpdateItem.doorlock.pincodeVersion !== "V4" ||
                  selectedKeyType !== "pincode") && (
                  <>
                    <div className="card-text">
                      <p>
                        {/* <FontAwesomeIcon icon={faHourglassStart}/> */}
                        <b>{t("data_column.start_at")}</b>
                        <span className="required">*</span>
                      </p>
                      <DatePicker
                        disabled={
                          selectedKeyType === "pincode" && !keyIssueItem.type
                        }
                        dateFormat="yyyy-MM-dd HH:mm"
                        placeholderText={t("placeholder.start_at")}
                        selected={keyIssueItem.checkinAt}
                        selectsStart
                        minDate={limitCheckInOutAt.minCheckinAt}
                        maxDate={limitCheckInOutAt.maxCheckoutAt}
                        endDate={keyIssueItem.checkoutAt}
                        showTimeSelect
                        filterTime={validateStartAt}
                        timeFormat="HH:mm"
                        timeIntervals={setTimeInterval()}
                        timeCaption="Time"
                        onChange={(date) => changeKeyStartAt(date)}
                        withPortal
                      />
                    </div>
                    <div className="card-text">
                      <p>
                        {/* <FontAwesomeIcon icon={faHourglassEnd}/> */}
                        <b>{t("data_column.end_at")}</b>
                        <span className="required">*</span>
                      </p>
                      <DatePicker
                        disabled={!keyIssueItem.checkinAt}
                        dateFormat="yyyy-MM-dd HH:mm"
                        placeholderText={t("placeholder.end_at")}
                        selected={keyIssueItem.checkoutAt}
                        selectsEnd
                        minDate={limitCheckInOutAt.minCheckinAt}
                        maxDate={limitCheckInOutAt.maxCheckoutAt}
                        startDate={keyIssueItem.checkinAt}
                        showTimeSelect
                        filterTime={validateEndAt}
                        timeFormat="HH:mm"
                        timeIntervals={setTimeInterval()}
                        timeCaption="Time"
                        onChange={(date) => changeKeyEndAt(date)}
                        withPortal
                      />
                    </div>
                  </>
                )}
                <div className="card-text">
                  <p>
                    {/* <FontAwesomeIcon icon={faBookOpen}/> */}
                    <b>{t("data_column.issue_type")}</b>
                    <span className="required">*</span>
                  </p>
                  <select
                    className="card-text-select"
                    value={keyIssueItem.isNew}
                    onChange={(e) =>
                      setKeyIssueItem({
                        ...keyIssueItem,
                        isNew: e.target.value,
                      })
                    }
                  >
                    {roomUpdateItem.doorlock.pincodeVersion === "V2" ||
                    selectedKeyType === "mobilekey"
                      ? howToIssueV2List.map((howToIssue, index) => (
                          <option key={index} value={howToIssue.value}>
                            {howToIssue.key}
                          </option>
                        ))
                      : howToIssueList.map((howToIssue, index) => (
                          <option key={index} value={howToIssue.value}>
                            {howToIssue.key}
                          </option>
                        ))}
                  </select>
                </div>
              </div>
            </div>
            <div className="card-foot">
              <div className="form-item-cancel">
                <button
                  className="btn-item-cancel"
                  onClick={() => cancelBooking()}
                >
                  <FontAwesomeIcon
                    icon={faArrowCircleLeft}
                    style={{ paddingRight: "3px" }}
                  />
                  <span>{t("button.cancel")}</span>
                </button>
              </div>
              <div className="form-item-add center">
                <button className="btn-item-add" onClick={() => issueKey()}>
                  <FontAwesomeIcon
                    icon={faSave}
                    style={{ paddingRight: "2px" }}
                  />
                  <span>{t("button.save")}</span>
                </button>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
      <ResponseSuccessModal
        isOpen={isOpenBookingCreateSuccessModal}
        toggle={() =>
          setIsOpenBookingCreateSuccessModal(!isOpenBookingCreateSuccessModal)
        }
        message={t("success_message.add_booking")}
      />
      <ResponseFailModal
        isOpen={isOpenRequiredParameterFailModal}
        toggle={() =>
          setIsOpenRequiredParameterFailModal(!isOpenRequiredParameterFailModal)
        }
        message={t("error_message.missing_parameter")}
      />
      <ResponseFailModal
        isOpen={isOpenBookingCreateFailModal}
        toggle={() =>
          setIsOpenBookingCreateFailModal(!isOpenBookingCreateFailModal)
        }
        message={messageBookingCreateFail || t("error_message.add_booking")}
      />
      <ResponseFailModal
        isOpen={isOpenKeyIssueFailModal}
        toggle={() => setIsOpenKeyIssueFailModal(!isOpenKeyIssueFailModal)}
        message={messageKeyIssueFail || t("error_message.issue_key")}
      />
      <SMSSend
        isOpen={isOpenKeyIssueSuccessModal}
        toggle={() =>
          setIsOpenKeyIssueSuccessModal(!isOpenKeyIssueSuccessModal)
        }
        smsSendItem={{ ...SMSSendItem, bookingId: selectedBookingId }}
        reload={() => {
          reload();
          toggle();
        }}
      />
    </Fragment>
  );
};

export default BookingCreate;
